export type ServiceConfig = {
  id: string;
  slugs: {
    en: string;
    fr: string;
  };
  projects: string[];
};

export const servicesConfig: ServiceConfig[] = [
  {
    id: 'strategicConsulting',
    slugs: {
      en: 'strategic-consulting',
      fr: 'consultation-strategique',
    },
    projects: [
      'enforcing-whistleblowers-rights',
      'reinventing-long-term-hospitality',
      'custom-changelog-builder-to-improve-team-devops',
    ],
  },
  {
    id: 'architectureDevelopment',
    slugs: {
      en: 'architecture-development',
      fr: 'architecture-developpement',
    },
    projects: [
      'reinventing-long-term-hospitality',
      'one-stop-packaging-solution',
      'enforcing-whistleblowers-rights',
    ],
  },
  {
    id: 'uxDesign',
    slugs: {
      en: 'ux-ui-design',
      fr: 'design-experience-utilisateur',
    },
    projects: [
      'one-stop-packaging-solution',
      'reinventing-long-term-hospitality',
      'custom-changelog-builder-to-improve-team-devops',
    ],
  },
  {
    id: 'projectManagement',
    slugs: {
      en: 'project-management-innovation',
      fr: 'gestion-projets-innovation',
    },
    projects: [
      'enforcing-whistleblowers-rights',
      'multi-tenant-platform-for-property-management',
      'reinventing-long-term-hospitality',
    ],
  },
  {
    id: 'marketingGrowth',
    slugs: {
      en: 'digital-marketing-growth',
      fr: 'marketing-numerique-croissance',
    },
    projects: [
      'one-stop-packaging-solution',
      'reinventing-long-term-hospitality',
    ],
  },
  {
    id: 'enablementTraining',
    slugs: {
      en: 'enablement-training',
      fr: 'accompagnement-formation',
    },
    projects: [
      'custom-changelog-builder-to-improve-team-devops',
      'multi-tenant-platform-for-property-management',
    ],
  },
];

export const getServiceBySlug = (slug: string) =>
  servicesConfig.find(
    (service) => service.slugs.en === slug || service.slugs.fr === slug,
  );

export const getServicesPath = (lang: 'en' | 'fr') => `/${lang}/services`;

export const getServicePath = (lang: 'en' | 'fr', slug: string) =>
  `/${lang}/services/${slug}`;
